define('gameday-index-url-hasher/enums/HashEvents',{
    UPDATE             : "gameParamsChanged",
	GAME_ID_CHANGED    : "gameIdChanged",
	GAME_STATE_CHANGED : "gameStateChanged",
	SELECTED_TAB_CHANGED: "selectedTabChanged",
	TFS_TIME_CHANGED   : "tfsTimeChanged",
	TFS_HOLD_SWITCHED  : "tfsHoldSwitched",
	PLAYER_SELECTED    : "playerDisplaySelected",
    EGGS               : "eggs"
});
